var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHalfStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8209 0.896362C10.8209 0.896362 10.8208 0.896362 10.8207 0.896362C10.6504 0.896362 10.4836 0.941859 10.3401 1.02747C10.1967 1.11308 10.0825 1.23522 10.0111 1.37944L7.452 6.55082L1.38771 7.22177C1.21851 7.24039 1.05858 7.30383 0.926841 7.40456C0.795103 7.50529 0.697073 7.63911 0.644352 7.79016C0.591632 7.94122 0.586428 8.1032 0.629356 8.25693C0.672284 8.41066 0.761548 8.54971 0.886583 8.65761L5.37172 12.5237L4.18133 18.1108C4.14826 18.2665 4.16372 18.4278 4.22586 18.5756C4.28801 18.7235 4.39424 18.8516 4.53201 18.9449C4.66978 19.0382 4.83332 19.0928 5.0033 19.1022C5.17327 19.1116 5.34258 19.0754 5.4912 18.9979L10.8207 16.216L10.8209 16.2161V0.896362Z",
    fill: "#FFBA53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfStar);
export default __webpack_public_path__ + "static/media/half-star.f7620bcb59cfd42edda496ce9cf6e828.svg";
export { ForwardRef as ReactComponent };